import _ from 'lodash'
import smsJournalApi from '@/api/sms-journal'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 25,
    phone: '',
    status: null,
    dateFrom: null,
    dateTo: null,
  },
}

const getters = {}

const actions = {
  fetchList({ commit }) {
    commit('LIST_LOADING')

    return smsJournalApi.getAll({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
      .catch(() => commit('SET_LIST', { items: [], metadata: { totalItemCount: 0 } }))
  },
}

const mutations = {
  LIST_LOADING(state) {
    state.loading = true
  },
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
  },
  ...generateFormHandlerMutations(state),
}

const watchers = [
  [
    ({ smsJournal: { filters } }) => [filters.phone, filters.status, filters.dateFrom, filters.dateTo].join('|'),
    () => store.commit('smsJournal/FORM_UPDATE_FIELD', { key: 'filters.pageNumber', value: 1 }),
  ],
  [
    state => state.smsJournal.filters,
    _.debounce(async () => await store.dispatch('smsJournal/fetchList'), 250),
    { immediate: false, deep: true },
  ],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  watchers,
}
